module.exports = __webpack_public_path__ + "img/car_green.2988d96f.svg";